import { useEffect } from 'react';

interface SeoOptions {
  title: string;
  description: string;
  keywords?: string;
  image?: string;
  type?: string;
  jsonLd?: object[];
}

const SITE = '吃瓜日报';

function upsertMeta(attr: 'name' | 'property', key: string, content: string) {
  let el = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

function removeOldJsonLd() {
  document.querySelectorAll('script[data-site-jsonld]').forEach((n) => n.remove());
}

function injectJsonLd(data: object[]) {
  removeOldJsonLd();
  data.forEach((obj, idx) => {
    const s = document.createElement('script');
    s.type = 'application/ld+json';
    s.setAttribute('data-site-jsonld', String(idx));
    s.textContent = JSON.stringify(obj);
    document.head.appendChild(s);
  });
}

export function useSeo({
  title,
  description,
  keywords = '',
  image = '',
  type = 'website',
  jsonLd = [],
}: SeoOptions) {
  useEffect(() => {
    document.title = `${title} - ${SITE}`;
    upsertMeta('name', 'description', description);
    upsertMeta('name', 'keywords', keywords);
    upsertMeta('property', 'og:title', `${title} - ${SITE}`);
    upsertMeta('property', 'og:description', description);
    upsertMeta('property', 'og:type', type);
    upsertMeta('property', 'og:site_name', SITE);
    upsertMeta('name', 'twitter:card', 'summary_large_image');
    upsertMeta('name', 'twitter:title', `${title} - ${SITE}`);
    upsertMeta('name', 'twitter:description', description);

    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) canonical.setAttribute('href', window.location.origin + window.location.pathname);

    const urlMeta = upsertMeta('property', 'og:url', window.location.origin + window.location.pathname);
    void urlMeta;

    if (image) {
      upsertMeta('property', 'og:image', image);
      upsertMeta('name', 'twitter:image', image);
    }

    if (jsonLd.length) {
      injectJsonLd(jsonLd);
    } else {
      removeOldJsonLd();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [title, description, keywords, image, type]);
}